import allImgPaths from 'assets/images'
import React, { useEffect, useState } from 'react'
import TimePicker from 'react-time-picker'

const RfpTime = ({ data: dataObj, handleDataChange }: any) => {
    const [startTime, setStartTime]: any = useState(dataObj?.content?.startTime || '');
    const [endTime, setEndTime]: any = useState(dataObj?.content?.endTime || '');

    useEffect(() => {
        if (dataObj?.updatedTime) {
            setStartTime(dataObj?.content?.startTime)
            setEndTime(dataObj?.content?.endTime)
        }
    }, [dataObj?.updatedTime])

    const handleStartTime = (value: any) => {
        setStartTime(value)
        handleDataChange({ key: 'startTime', value })
    }

    const handleEndTime = (value: any) => {
        setEndTime(value)
        handleDataChange({ key: 'endTime', value })
    }

    return (
        <>
            <div className="flex items-center mb-6 gap-x-6">
                <div className="w-72">
                    <p className='text-[#344054] text-sm font-interMedium pb-1.5 pl-1'>Start Time</p>
                    <div className="relative">
                        <div className="border border-[#D0D5DD] rounded-lg flex items-center gap-x-2 py-2 px-3 hover:border-[#1e0af5] focus-within:border-[#1e0af5]">
                            <img
                                className="w-[22px] h-[22px] flex-shrink-0 "
                                src={allImgPaths.clockIcon}
                                alt="star icon"
                            />
                            <div className="custom-timepicker w-full">
                                <TimePicker onChange={handleStartTime} value={startTime} clockIcon={null} clearIcon={null} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="w-72">
                    <p className='text-[#344054] text-sm font-interMedium pb-1.5 pl-1'>End Time</p>
                    <div className="relative">
                        <div className="border border-[#D0D5DD] rounded-lg flex items-center gap-x-2 py-2 px-3 hover:border-[#1e0af5] focus-within:border-[#1e0af5]">
                            <img
                                className="w-[22px] h-[22px] flex-shrink-0 "
                                src={allImgPaths.clockIcon}
                                alt="star icon"
                            />
                            <div className="custom-timepicker w-full">
                                <TimePicker onChange={handleEndTime} value={endTime} clockIcon={null} clearIcon={null} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default RfpTime